import React, { useEffect, useState } from "react";
import { THUMBNAIL_PREVIEWS } from "../../../config/constants";
import { useTranslate } from "@tolgee/react";
import PostPreview from "./postPreview";
import IGGridPreview from "./IGGridPreview";
import { useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../../pages/lomavisCreator";
import { INSTAGRAM } from "../../../../../config/constants";
import { Tooltip } from "bootstrap";
import { EditorHeader } from "../../sharedComponents";
import EditorTitle from "../../commonElements/editorTitle";

const ThumbnailPreviews = ({ platform, videoUrl, startSubmission }) => {
  const { t } = useTranslate();
  const [preview, setPreview] = useState(THUMBNAIL_PREVIEWS.POST_PREVIEW);

  const IGThumbnailImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[INSTAGRAM].uploadedImageThumbnail
  );
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );

  const IGTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("IG_warning_tooltip")}
              </div>
            </div></div>'`;

  useEffect(() => {
    const tooltipTrigger = document.querySelector(".tooltip-trigger");

    tooltipTrigger &&
      new Tooltip(tooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: IGTooltip,
      });
  }, []);

  return (
    <div className="w-100 h-100">
      <div className="w-100 d-flex flex-column gap-4 h-100 ">
        {!startSubmission && (
          <EditorHeader>
            <EditorTitle title={"preview"} toolTip={false} />

            <div className="btn-group">
              <button
                type="button"
                className={`btn btn-secondary btn-sm d-flex justify-content-center align-items-center ${
                  preview === THUMBNAIL_PREVIEWS.POST_PREVIEW ? "active" : ""
                }`}
                onClick={() => setPreview(THUMBNAIL_PREVIEWS.POST_PREVIEW)}
              >
                <i className="fa-duotone fa-hashtag"></i>

                {t("lomavisCreator.IG_post_preview")}
              </button>
              {platformEnabled[INSTAGRAM] && (
                <button
                  type="button"
                  data-bs-toggle={IGThumbnailImage ? "" : "tooltip"}
                  className={`${
                    IGThumbnailImage ? "" : "tooltip-trigger"
                  } btn btn-secondary btn-sm d-flex justify-content-center align-items-center rounded-0 rounded-end ${
                    preview === THUMBNAIL_PREVIEWS.IG_GRID_PREVIEW
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setPreview(THUMBNAIL_PREVIEWS.IG_GRID_PREVIEW);
                  }}
                  disabled={IGThumbnailImage ? false : true}
                >
                  <i className="fa-brands fa-instagram text-danger"></i>
                  {t("LomavisCreator.instagram_grid")}
                </button>
              )}
            </div>
          </EditorHeader>
        )}
        <div className="d-flex flex-column gap-3 flex-fill h-100 bg-white rounded-3 py-6">
          {preview === THUMBNAIL_PREVIEWS.POST_PREVIEW ? (
            <PostPreview platform={platform} videoUrl={videoUrl} />
          ) : (
            platformEnabled[INSTAGRAM] && <IGGridPreview platform={platform} />
          )}
        </div>{" "}
      </div>
    </div>
  );
};

export default ThumbnailPreviews;
